import { IGetClientResModule } from '@msg91/models/root-models';
import { IAdminMeData, IUserPermissions } from '@msg91/models/super-admin-models';
import { Action, createReducer, on } from '@ngrx/store';
import { rootActions } from '../../actions';
import { DEFAULT_ONE_DAY_DATE_RANGE_WITH_TIME } from '@admin/src/app/libs/constant';
import { uniq } from 'lodash';

export interface IRootState {
    selectedWhatsappNumber: any;
    errors: string[];
    headerTitle: string;
    clients: IGetClientResModule[];

    clientsInProcess: boolean;
    clientsSuccess: boolean;

    selectedClient: IGetClientResModule;
    showClientList: boolean;

    sideBarToggleStatus: boolean;

    inboundEmailLogPermission: boolean;

    editUserPermission: boolean;

    token: string;
    dateRange: {
        start: Date;
        end: Date;
    };
    integratedFbCloudNumbers: string[];
    integratedHaptikNumbers: string[];
    allWhatsAppIntegratedNumbers: string[];
    integrated360Numbers: string[];
    userRulePermissionSuccess: boolean;
    whatsAppNumberNameMap: { [number: string]: string };

    /** GET /api/me */
    adminMe: IAdminMeData | null;
    adminMeLoaded: boolean;
    adminMeInProcess: boolean;
    microservicePermissions: IUserPermissions;
    platformPermissions: string[];
}

export const initialState: IRootState = {
    errors: null,

    headerTitle: null,

    clients: null,
    clientsInProcess: false,
    clientsSuccess: false,
    selectedClient: null,
    // selectedClient: {
    //     // intentionally commented out for testing
    //     user_pid: '279417',
    //     user_name: 'whatsapptest    ',
    //     user_fname: 'whatsapptest   ',
    //     user_lname: '',
    //     user_uname: 'msg91testwhatsapp',
    //     user_mobno: '919499179391',
    //     user_email: 'amenadiel@whozzat.com',
    //     user_type: '3',
    //     user_rid: '2',
    //     user_expiry: '',
    //     user_currency: 'INR',
    //     user_status: '1',
    //     user_date: '3 years and 1 month ago',
    //     signup_date: '2023-05-08 13:24:00',
    //     userPanelId: '1',
    //     userWalletEnabled: 1,
    //     billing_country_name: 'India',
    //     billing_country_shortname: 'IN',
    //     user_timezone: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    // } as any,
    showClientList: false,

    editUserPermission: false,

    sideBarToggleStatus: false,

    inboundEmailLogPermission: false,
    token: null,
    dateRange: DEFAULT_ONE_DAY_DATE_RANGE_WITH_TIME,
    selectedWhatsappNumber: null,
    integratedFbCloudNumbers: null,
    integratedHaptikNumbers: null,
    allWhatsAppIntegratedNumbers: null,
    integrated360Numbers: null,
    userRulePermissionSuccess: false,
    whatsAppNumberNameMap: {},

    adminMe: null,
    adminMeLoaded: false,
    adminMeInProcess: false,
    microservicePermissions: {},
    platformPermissions: [],
};

export function rootReducer(state: IRootState, action: Action) {
    return _rootReducer(state, action);
}

const _rootReducer = createReducer(
    initialState,
    on(rootActions.headerTitleAction, (state, { title }) => {
        return {
            ...state,
            headerTitle: title,
        };
    }),

    on(rootActions.getClientAction, (state) => {
        return {
            ...state,
            clients: [],
            clientsInProcess: true,
            clientsSuccess: false,
            errors: [],
        };
    }),
    on(rootActions.getClientActionComplete, (state, { response }) => {
        return {
            ...state,
            clients: response.data,
            clientsInProcess: false,
            clientsSuccess: true,
            errors: [],
        };
    }),
    on(rootActions.getClientActionError, (state, { errors }) => {
        return {
            ...state,
            clients: null,
            clientsInProcess: false,
            clientsSuccess: false,
            errors: errors,
        };
    }),

    on(rootActions.setSelectedClient, (state, { response }) => {
        return {
            ...state,
            selectedClient: response,
        };
    }),

    on(rootActions.setShowClientList, (state, { response }) => {
        return {
            ...state,
            showClientList: response,
        };
    }),

    on(rootActions.setSideBarToggleStatus, (state, { status }) => {
        return {
            ...state,
            sideBarToggleStatus: status,
        };
    }),

    on(rootActions.getUserInboundEmailPermissionSuccess, (state, action) => {
        return {
            ...state,
            inboundEmailLogPermission: action?.payload.includes('can_view_inbound_email_log'),
            editUserPermission:
                action?.payload.includes('can_edit_user_permissions') &&
                action?.payload.includes('can_view_inbound_email_log'),
        };
    }),

    on(rootActions.setFCMToken, (state, { token }) => {
        return {
            ...state,
            token,
        };
    }),
    on(rootActions.setDateRange, (state, { dateRange }) => {
        return {
            ...state,
            dateRange,
        };
    }),
    on(rootActions.setSelectedWhatsappNumber, (state, { response }) => {
        return {
            ...state,
            selectedWhatsappNumber: response,
        };
    }),
    on(rootActions.setIntegratedFbCloudNumbers, (state, { integratedFbNumbers }) => {
        return {
            ...state,
            integratedFbCloudNumbers: integratedFbNumbers,
        };
    }),
    on(rootActions.setIntegratedHaptikNumbers, (state, { integratedHaptikNumbers }) => {
        return {
            ...state,
            integratedHaptikNumbers,
        };
    }),
    on(rootActions.setAllWhatsAppIntegratedNumbers, (state, { allWhatsAppIntegratedNumbers }) => {
        return {
            ...state,
            allWhatsAppIntegratedNumbers: uniq(allWhatsAppIntegratedNumbers),
        };
    }),
    on(rootActions.setIntegrated360Numbers, (state, { numbers }) => {
        return {
            ...state,
            integrated360Numbers: numbers,
        };
    }),

    on(rootActions.getAdminMe, (state) => {
        return {
            ...state,
            adminMeInProcess: true,
            adminMeLoaded: false,
        };
    }),
    on(rootActions.getAdminMeSuccess, (state, { payload }) => {
        return {
            ...state,
            adminMe: payload,
            adminMeInProcess: false,
            adminMeLoaded: true,
            microservicePermissions: payload?.microservice_permissions || {},
            platformPermissions: payload?.permissions || [],
        };
    }),
    on(rootActions.getAdminMeError, (state) => {
        return {
            ...state,
            adminMe: null,
            adminMeInProcess: false,
            adminMeLoaded: true,
            microservicePermissions: {},
            platformPermissions: [],
        };
    })
);
